import { Node } from 'neovis.js';
import * as Papa from 'papaparse';

export interface ImportExcelValuesInterface {
  id: number
  Tipo_De_Nodo: string;
  Nombre: string;
  Valor: number;
  Forma: string;
  Imagen: string;
}

const DEBUG_MODE = false;

if (DEBUG_MODE) {
  console.log('DEBUG_MODE is enabled in import-excel');
}

function transformRawExcelData(data: ImportExcelValuesInterface, id: number): any {
  return {
    identity: id,
    labels: [data.Tipo_De_Nodo],
    properties: {
      Nombre: data.Nombre,
      Valor: data.Valor,
    }
  }
}

export async function ImportNodesFunction(event: any, neovis: any) {
  const nodesCsvData = event.target.result;
  const nodes = Papa.parse(nodesCsvData, { header: true }).data;
  if (DEBUG_MODE) console.log('Import Nodes:', nodes);
  const defaultFont = { "color": "#fff", "strokeWidth": 0, "background": "#110c2a", "size": 10 };
  const nodesData = nodes.map((data: ImportExcelValuesInterface): Node => {
    let processedData: Node = {
      id: data.id,
      raw: transformRawExcelData(data, data.id),
      label: data.Nombre,
      value: data.Valor,
      shape: data.Forma,
      font: defaultFont,
    }
    if (data.Imagen) processedData.image = data.Imagen;
    return processedData
  });
  if (DEBUG_MODE) console.log('Nodes Data:', nodesData);
  try {
    await neovis.nodes.add(nodesData);
    if (DEBUG_MODE) console.log("Nodos agregados con éxito");
  } catch (error) {
    if (DEBUG_MODE) console.error("Error al agregar nodos:", error);
  }
}

export async function ImportEdgesFunction(event: any, neovis: any) {
  const edgesCsvData = event.target.result;
  const edges = Papa.parse(edgesCsvData, { header: true }).data;

  if (DEBUG_MODE) {
    console.log('Edges:', edges);
  }

  const x = {
    "id": 3866,
    "from": 823,
    "to": 103257,
    "raw": {
      "identity": 3866,
      "start": 823,
      "end": 103257,
      "type": "HAS_ACCOUNT",
      "properties": {
        "account": 1
      }
    },
    "value": 1
  }

  for (let edge of edges) {
    try {
      const new_edge = {
        id: edge.id,
        from: edge.from,
        to: edge.to,
        value: edge.value,
        raw: {
          identity: edge.id,
          start: edge.from,
          end: edge.to,
          type: 'HAS_ACCOUNT',
          properties: JSON.parse(edge.properties),
        }
      }
      await neovis.edges.add(new_edge);
    } catch (error) {
      console.error(`Error adding node: ${error.message}`);
    }
  }
}

